import { Box } from "@mui/material";
import { useParams } from "react-router";
import RoleModule from "./RoleModule";

function RoleModuleScreen() {
    const { id } = useParams();
    return (
        <Box>
            <RoleModule.Grid baseFilters={[{
                field: "RoleId",
                operator: "equals",
                value: parseInt(id),
                type: "number"
            },
            {
                field: "IsDisplay",
                operator: "equals",
                value: true,
                type: "boolean"
            }]} />
        </Box>
    );
}

export default RoleModuleScreen;